'use client';

import classNames from 'classnames';
import Link from 'next/link';

import { ExternalLink } from '@/components/ExternalLink';
import { ABOUT_PAGE_PATH, CONTACT_PAGE_PATH } from '@/helpers/linkHelpers';
import ArrowSquareOut from '@/icons/react/ArrowSquareOut';
import { isAbsoluteUrl } from '@/lib/parseLink';
import { useSiteHeader } from '@/providers';

export function LinksList() {
  const { setMobileMenuOpen } = useSiteHeader();

  const links = [
    {
      linkText: 'About 1440',
      href: ABOUT_PAGE_PATH,
    },
    {
      linkText: 'Contact',
      href: CONTACT_PAGE_PATH,
    },
  ];

  const linkClasses = classNames(
    'flex items-center gap-1 px-4 md:px-2 py-3 md:py-2 underline text-body-450 lg:px-4',
    'md:no-underline md:text-secondary md:text-body-400 md:hover:underline md:hover:text-black',
  );

  return (
    <nav className="md:-mr-2">
      <ul className="flex flex-col md:flex-row gap-0">
        {links?.map((link) => (
          <li key={link.href}>
            {isAbsoluteUrl(link.href) ? (
              <ExternalLink
                className={linkClasses}
                href={link.href}
                trackingContext="mobile_menu_footer_links"
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.linkText}
                <ArrowSquareOut className="text-secondary" />
              </ExternalLink>
            ) : (
              <Link
                className={linkClasses}
                href={link.href}
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.linkText}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
}
